<template>
  <el-switch
    :model-value="currentValue"
    :active-color="activeColor"
    :inactive-color="inactiveColor"
    :width="width"
    @change="onChange"
  />
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    modelValue: {
      type: [Boolean, String, Number],
      default: false
    },
    value: {
      type: [Boolean, String, Number],
      default: undefined
    },
    labels: {
      type: Object,
      default: () => ({ checked: 'On', unchecked: 'Off' })
    },
    color: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: Number,
      default: 50
    },
    sync: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentValue () {
      return typeof this.modelValue !== 'undefined' ? this.modelValue : this.value
    },
    activeColor () {
      return this.color && this.color.checked ? this.color.checked : '#78BB95'
    },
    inactiveColor () {
      return this.color && this.color.unchecked ? this.color.unchecked : 'rgba(0, 0, 0, 0.15)'
    }
  },
  methods: {
    onChange (value) {
      this.$emit('update:modelValue', value)
      this.$emit('change', value)
    }
  }
}
</script>
